import type { RemixPhase } from '@atlassian/malleable-ui-components/state/machine';

/**
 * Renderer-owned lifecycle vocabulary.
 *
 * This vocabulary describes renderer behavior rather than exposing the raw
 * machine phase union. `submitting` is the renderer projection of the machine's
 * `inserting` phase.
 */
export type RendererRemixLifecyclePhase =
	| 'inactive'
	| 'thinking'
	| 'ready'
	| 'previewing'
	| 'submitting'
	| 'error'
	| 'aborted';

export type RendererRemixTerminalPhase = Extract<RendererRemixLifecyclePhase, 'error' | 'aborted'>;

const machineToRendererPhase = {
	thinking: 'thinking',
	ready: 'ready',
	previewing: 'previewing',
	inserting: 'submitting',
	error: 'error',
	aborted: 'aborted',
} as const satisfies Record<RemixPhase, RendererRemixLifecyclePhase>;

export const deriveMachineRendererRemixPhase = (
	phase: RemixPhase | undefined,
): RendererRemixLifecyclePhase =>
	phase === undefined ? 'inactive' : machineToRendererPhase[phase];
